var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBestValue2025 = function SvgIconBestValue2025(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "IconBestValue2025_svg__Layer_2",
    "data-name": "Layer 2",
    viewBox: "0 0 1080 1080"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "IconBestValue2025_svg__clippath"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 539.87,
    cy: 539.68,
    r: 452.12,
    className: "IconBestValue2025_svg__cls-1"
  })), /*#__PURE__*/React.createElement("style", null, ".IconBestValue2025_svg__cls-1{fill:none}.IconBestValue2025_svg__cls-5{fill:#2f1a20}.IconBestValue2025_svg__cls-15{fill:#eaeaea}.IconBestValue2025_svg__cls-16{fill:#301b21}.IconBestValue2025_svg__cls-19{fill:#2c161c}.IconBestValue2025_svg__cls-33{fill:#281218}.IconBestValue2025_svg__cls-41{fill:#331e24}.IconBestValue2025_svg__cls-47{fill:#2d181e}.IconBestValue2025_svg__cls-48{fill:#2d171d}.IconBestValue2025_svg__cls-50{fill:#341f25}.IconBestValue2025_svg__cls-52{fill:#291319}.IconBestValue2025_svg__cls-60{fill:#2a141a}.IconBestValue2025_svg__cls-65{fill:#362127}.IconBestValue2025_svg__cls-73{fill:#352026}.IconBestValue2025_svg__cls-76{fill:#2e191f}.IconBestValue2025_svg__cls-95{fill:#311c22}.IconBestValue2025_svg__cls-114{fill:#2b151b}"))), /*#__PURE__*/React.createElement("g", {
    id: "IconBestValue2025_svg__Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#IconBestValue2025_svg__clippath)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m991.99 102.37-5.82-14.81h5.82z",
    style: {
      fill: "#958a8d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m991.99 117.65-11.83-30.09h6.01l5.82 14.81z",
    style: {
      fill: "#94898c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m991.99 132.93-17.84-45.37h6.01l11.83 30.09z",
    style: {
      fill: "#93878a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m991.99 148.21-23.84-60.65h6l17.84 45.37z",
    style: {
      fill: "#918689"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m991.99 163.49-29.85-75.93h6.01l23.84 60.65z",
    style: {
      fill: "#908588"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m991.99 178.77-35.86-91.21h6.01l29.85 75.93z",
    style: {
      fill: "#8f8386"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.99 194.05 950.13 87.56h6l35.86 91.21z",
    style: {
      fill: "#8e8285"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.99 209.33 944.12 87.56h6.01l41.86 106.49z",
    style: {
      fill: "#8c8184"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.99 224.61 938.11 87.56h6.01l47.87 121.77z",
    style: {
      fill: "#8b7f83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.99 239.89 932.1 87.56h6.01l53.88 137.05z",
    style: {
      fill: "#8a7e81"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.99 255.17 926.1 87.56h6l59.89 152.33z",
    style: {
      fill: "#897d80"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m991.99 270.45-71.9-182.89h6.01l65.89 167.61z",
    style: {
      fill: "#887b7f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.99 285.73 914.08 87.56h6.01l71.9 182.89z",
    style: {
      fill: "#867a7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.99 301.01 908.08 87.56h6l77.91 198.17z",
    style: {
      fill: "#85797c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.99 316.29 902.07 87.56h6.01l83.91 213.45z",
    style: {
      fill: "#84787b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.99 331.57 896.06 87.56h6.01l89.92 228.73z",
    style: {
      fill: "#83767a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.99 346.85 890.05 87.56h6.01l95.93 244.01z",
    style: {
      fill: "#827579"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.99 362.13 884.05 87.56h6l101.94 259.29z",
    style: {
      fill: "#817477"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.99 377.41 878.04 87.56h6.01l107.94 274.57z",
    style: {
      fill: "#807376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.99 392.69 872.03 87.56h6.01l113.95 289.85z",
    style: {
      fill: "#7e7175"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.99 407.97 866.02 87.56h6.01l119.96 305.13z",
    style: {
      fill: "#7d7074"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.99 423.25 860.02 87.56h6l125.97 320.41z",
    style: {
      fill: "#7c6f72"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.99 438.53 854.01 87.56h6.01l131.97 335.69z",
    style: {
      fill: "#7b6e71"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.99 453.81 848 87.56h6.01l137.98 350.97z",
    style: {
      fill: "#7a6c70"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.99 469.09 842 87.56h6l143.99 366.25z",
    style: {
      fill: "#796b6f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m991.99 484.37-156-396.81H842l149.99 381.53z",
    style: {
      fill: "#786a6e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.99 499.65 829.98 87.56h6.01l156 396.81z",
    style: {
      fill: "#77696d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.99 514.93 823.97 87.56h6.01l162.01 412.09z",
    style: {
      fill: "#76686b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.99 530.21 817.97 87.56h6l168.02 427.37z",
    style: {
      fill: "#75666a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.99 545.49 811.96 87.56h6.01l174.02 442.65z",
    style: {
      fill: "#746569"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.99 560.77 805.95 87.56h6.01l180.03 457.93z",
    style: {
      fill: "#726468"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.99 576.05 799.95 87.56h6l186.04 473.21z",
    style: {
      fill: "#716367"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.99 591.33 793.94 87.56h6.01l192.04 488.49z",
    style: {
      fill: "#706266"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.99 606.61 787.93 87.56h6.01l198.05 503.77z",
    style: {
      fill: "#6f6165"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.99 621.89 781.92 87.56h6.01l204.06 519.05z",
    style: {
      fill: "#6e6064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.99 637.17 775.92 87.56h6l210.07 534.33z",
    style: {
      fill: "#6d5e63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.99 652.45 769.91 87.56h6.01l216.07 549.61z",
    style: {
      fill: "#6c5d61"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.99 667.73 763.9 87.56h6.01l222.08 564.89z",
    style: {
      fill: "#6b5c60"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.99 683.01 757.89 87.56h6.01l228.09 580.17z",
    style: {
      fill: "#6a5b5f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.99 698.29 751.89 87.56h6l234.1 595.45z",
    style: {
      fill: "#695a5e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.99 713.57 745.88 87.56h6.01l240.1 610.73z",
    style: {
      fill: "#68595d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.99 728.85 739.87 87.56h6.01l246.11 626.01z",
    style: {
      fill: "#67585c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.99 744.13 733.87 87.56h6l252.12 641.29z",
    style: {
      fill: "#66575b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.99 759.41 727.86 87.56h6.01l258.12 656.57z",
    style: {
      fill: "#65565a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.99 774.69 721.85 87.56h6.01l264.13 671.85z",
    style: {
      fill: "#655559"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.99 789.97 715.84 87.56h6.01l270.14 687.13z",
    style: {
      fill: "#645458"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.99 805.25 709.84 87.56h6l276.15 702.41z",
    style: {
      fill: "#635357"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.99 820.53 703.83 87.56h6.01l282.15 717.69z",
    style: {
      fill: "#625256"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.99 835.81 697.82 87.56h6.01l288.16 732.97z",
    style: {
      fill: "#615155"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.99 851.09 691.82 87.56h6l294.17 748.25z",
    style: {
      fill: "#605054"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.99 866.37 685.81 87.56h6.01l300.17 763.53z",
    style: {
      fill: "#5f4f53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.99 881.65 679.8 87.56h6.01l306.18 778.81z",
    style: {
      fill: "#5e4e52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.99 896.93 673.79 87.56h6.01l312.19 794.09z",
    style: {
      fill: "#5d4d51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.99 912.21 667.79 87.56h6l318.2 809.37z",
    style: {
      fill: "#5c4c50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m991.99 914.37-4.47 1.76L661.78 87.56h6.01l324.2 824.65z",
    style: {
      fill: "#5b4b4f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m987.52 916.13-5.2 2.04L655.77 87.56h6.01z",
    style: {
      fill: "#5b4a4e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m982.32 918.17-5.2 2.05L649.76 87.56h6.01z",
    style: {
      fill: "#5a494d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m977.12 920.22-5.21 2.04-328.15-834.7h6z",
    style: {
      fill: "#59484c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m971.91 922.26-5.2 2.05L637.75 87.56h6.01z",
    style: {
      fill: "#58474b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m966.71 924.31-5.2 2.05-329.77-838.8h6.01z",
    style: {
      fill: "#57464b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m961.51 926.36-5.21 2.04L625.74 87.56h6z",
    style: {
      fill: "#56454a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m956.3 928.4-5.2 2.05L619.73 87.56h6.01z",
    style: {
      fill: "#554449"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m951.1 930.45-5.2 2.04L613.72 87.56h6.01z",
    style: {
      fill: "#554348"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m945.9 932.49-5.21 2.05L607.71 87.56h6.01z",
    style: {
      fill: "#544247"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m940.69 934.54-5.2 2.04L601.71 87.56h6z",
    style: {
      fill: "#534146"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m935.49 936.58-5.2 2.05L595.7 87.56h6.01z",
    style: {
      fill: "#524045"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m930.29 938.63-5.2 2.04-335.4-853.11h6.01z",
    style: {
      fill: "#514044"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m925.09 940.67-5.21 2.05L583.69 87.56h6z",
    style: {
      fill: "#513f44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m919.88 942.72-5.2 2.04-337-857.2h6.01z",
    style: {
      fill: "#503e43"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m914.68 944.76-5.2 2.05L571.67 87.56h6.01z",
    style: {
      fill: "#4f3d42"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m909.48 946.81-5.21 2.05-338.61-861.3h6.01z",
    style: {
      fill: "#4e3c41"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m904.27 948.86-5.2 2.04L559.66 87.56h6z",
    style: {
      fill: "#4d3b40"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m899.07 950.9-5.2 2.05L553.65 87.56h6.01z",
    style: {
      fill: "#4d3a3f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m893.87 952.95-5.21 2.04L547.64 87.56h6.01z",
    style: {
      fill: "#4c3a3f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m888.66 954.99-5.2 2.05L541.63 87.56h6.01z",
    style: {
      fill: "#4b393e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m883.46 957.04-5.2 2.04L535.63 87.56h6z",
    style: {
      fill: "#4b383d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m878.26 959.08-5.21 2.05L529.62 87.56h6.01z",
    style: {
      fill: "#4a373c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m873.05 961.13-5.2 2.04L523.61 87.56h6.01z",
    style: {
      fill: "#49363c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m867.85 963.17-5.2 2.05L517.61 87.56h6z",
    style: {
      fill: "#48363b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m862.65 965.22-5.2 2.05L511.6 87.56h6.01z",
    style: {
      fill: "#48353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m857.45 967.27-5.21 2.04L505.59 87.56h6.01z",
    style: {
      fill: "#473439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m852.24 969.31-5.2 2.05-347.46-883.8h6.01z",
    style: {
      fill: "#463339"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m847.04 971.36-5.2 2.04L493.58 87.56h6z",
    style: {
      fill: "#463338"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m841.84 973.4-5.21 2.05L487.57 87.56h6.01z",
    style: {
      fill: "#453237"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m836.63 975.45-5.2 2.04L481.56 87.56h6.01z",
    style: {
      fill: "#443136"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m831.43 977.49-5.2 2.05L475.56 87.56h6z",
    style: {
      fill: "#443036"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m826.23 979.54-5.21 2.04L469.55 87.56h6.01z",
    style: {
      fill: "#433035"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m821.02 981.58-5.2 2.05L463.54 87.56h6.01z",
    style: {
      fill: "#422f34"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m815.82 983.63-5.2 2.05L457.53 87.56h6.01z",
    style: {
      fill: "#422e34"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m810.62 985.68-5.2 2.04L451.53 87.56h6z",
    style: {
      fill: "#412e33"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m805.42 987.72-5.21 2.05L445.52 87.56h6.01z",
    style: {
      fill: "#402d32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m800.21 989.77-5.17 2.03h-.03L439.51 87.56h6.01z",
    style: {
      fill: "#402c32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789 991.8 433.5 87.56h6.01l355.5 904.24z",
    style: {
      fill: "#3f2c31"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.99 991.8 427.5 87.56h6L789 991.8z",
    style: {
      fill: "#3f2b30"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.98 991.8 421.49 87.56h6.01L782.99 991.8z",
    style: {
      fill: "#3e2a30"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.98 991.8 415.48 87.56h6.01L776.98 991.8z",
    style: {
      fill: "#3d2a2f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M764.97 991.8 409.48 87.56h6l355.5 904.24z",
    style: {
      fill: "#3d292e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758.96 991.8 403.47 87.56h6.01L764.97 991.8z",
    style: {
      fill: "#3c282e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M752.95 991.8 397.46 87.56h6.01L758.96 991.8z",
    style: {
      fill: "#3c282d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M746.95 991.8 391.45 87.56h6.01L752.95 991.8z",
    style: {
      fill: "#3b272d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.94 991.8 385.45 87.56h6l355.5 904.24z",
    style: {
      fill: "#3b272c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.93 991.8 379.44 87.56h6.01L740.94 991.8z",
    style: {
      fill: "#3a262b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.93 991.8 373.43 87.56h6.01L734.93 991.8z",
    style: {
      fill: "#3a252b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.92 991.8 367.43 87.56h6l355.5 904.24z",
    style: {
      fill: "#39252a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.91 991.8 361.42 87.56h6.01L722.92 991.8z",
    style: {
      fill: "#38242a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.9 991.8 355.41 87.56h6.01L716.91 991.8z",
    style: {
      fill: "#382429"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.9 991.8 349.4 87.56h6.01L710.9 991.8z",
    style: {
      fill: "#372329"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.89 991.8 343.4 87.56h6L704.9 991.8z",
    style: {
      fill: "#372328"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.88 991.8 337.39 87.56h6.01L698.89 991.8z",
    style: {
      fill: "#372228"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M686.88 991.8 331.38 87.56h6.01L692.88 991.8z",
    className: "IconBestValue2025_svg__cls-65"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M680.87 991.8 325.38 87.56h6l355.5 904.24z",
    className: "IconBestValue2025_svg__cls-65"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M674.86 991.8 319.37 87.56h6.01L680.87 991.8z",
    className: "IconBestValue2025_svg__cls-73"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M668.85 991.8 313.36 87.56h6.01L674.86 991.8z",
    className: "IconBestValue2025_svg__cls-73"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M662.85 991.8 307.35 87.56h6.01L668.85 991.8z",
    className: "IconBestValue2025_svg__cls-50"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M656.84 991.8 301.35 87.56h6l355.5 904.24z",
    className: "IconBestValue2025_svg__cls-50"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M650.83 991.8 295.34 87.56h6.01L656.84 991.8z",
    className: "IconBestValue2025_svg__cls-41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M644.82 991.8 289.33 87.56h6.01L650.83 991.8z",
    className: "IconBestValue2025_svg__cls-41"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M638.82 991.8 283.51 88.03l1.19-.47h4.63L644.82 991.8z",
    style: {
      fill: "#321e23"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.81 991.8 278.31 90.08l5.2-2.05L638.82 991.8z",
    style: {
      fill: "#321d23"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.8 991.8 273.1 92.12l5.21-2.04 354.5 901.72z",
    style: {
      fill: "#321d22"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M620.8 991.8 267.9 94.17l5.2-2.05L626.8 991.8z",
    className: "IconBestValue2025_svg__cls-95"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M614.79 991.8 262.7 96.21l5.2-2.04L620.8 991.8z",
    className: "IconBestValue2025_svg__cls-95"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M608.78 991.8 257.49 98.26l5.21-2.05L614.79 991.8z",
    className: "IconBestValue2025_svg__cls-16"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M602.77 991.8 252.29 100.3l5.2-2.04L608.78 991.8z",
    className: "IconBestValue2025_svg__cls-16"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M596.77 991.8 247.09 102.35l5.2-2.05 350.48 891.5z",
    style: {
      fill: "#301b20"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M590.76 991.8 241.88 104.4l5.21-2.05L596.77 991.8z",
    className: "IconBestValue2025_svg__cls-5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M584.75 991.8 236.68 106.44l5.2-2.04 348.88 887.4z",
    className: "IconBestValue2025_svg__cls-5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M578.75 991.8 231.48 108.49l5.2-2.05L584.75 991.8z",
    style: {
      fill: "#2f191f"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M572.74 991.8 226.28 110.53l5.2-2.04L578.75 991.8z",
    className: "IconBestValue2025_svg__cls-76"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M566.73 991.8 221.07 112.58l5.21-2.05L572.74 991.8z",
    className: "IconBestValue2025_svg__cls-76"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M560.72 991.8 215.87 114.62l5.2-2.04L566.73 991.8z",
    style: {
      fill: "#2e181e"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M554.72 991.8 210.67 116.67l5.2-2.05L560.72 991.8z",
    className: "IconBestValue2025_svg__cls-47"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M548.71 991.8 205.46 118.71l5.21-2.04L554.72 991.8z",
    className: "IconBestValue2025_svg__cls-47"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M542.7 991.8 200.26 120.76l5.2-2.05L548.71 991.8z",
    className: "IconBestValue2025_svg__cls-48"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M536.69 991.8 195.06 122.81l5.2-2.05L542.7 991.8z",
    className: "IconBestValue2025_svg__cls-48"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M530.69 991.8 189.85 124.85l5.21-2.04L536.69 991.8z",
    style: {
      fill: "#2c171d"
    }
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M524.68 991.8 184.65 126.9l5.2-2.05L530.69 991.8z",
    className: "IconBestValue2025_svg__cls-19"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M518.67 991.8 179.45 128.94l5.2-2.04 340.03 864.9z",
    className: "IconBestValue2025_svg__cls-19"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M512.67 991.8 174.25 130.99l5.2-2.05L518.67 991.8z",
    className: "IconBestValue2025_svg__cls-19"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M506.66 991.8 169.04 133.03l5.21-2.04L512.67 991.8z",
    style: {
      fill: "#2b161c"
    }
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M500.65 991.8 163.84 135.08l5.2-2.05L506.66 991.8zM494.64 991.8l-336-854.68 5.2-2.04L500.65 991.8z",
    className: "IconBestValue2025_svg__cls-114"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M488.64 991.8 153.43 139.17l5.21-2.05 336 854.68z",
    className: "IconBestValue2025_svg__cls-114"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m482.63 991.8-334.4-850.58 5.2-2.05L488.64 991.8z",
    style: {
      fill: "#2a151b"
    }
  }), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M476.62 991.8 143.03 143.26l5.2-2.04 334.4 850.58z",
    className: "IconBestValue2025_svg__cls-60"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m470.62 991.8-332.8-846.49 5.21-2.05L476.62 991.8z",
    className: "IconBestValue2025_svg__cls-60"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M464.61 991.8 132.62 147.35l5.2-2.04 332.8 846.49z",
    className: "IconBestValue2025_svg__cls-60"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M458.6 991.8 127.42 149.4l5.2-2.05L464.61 991.8z",
    className: "IconBestValue2025_svg__cls-60"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M452.59 991.8 122.22 151.44l5.2-2.04L458.6 991.8z",
    style: {
      fill: "#29141a"
    }
  }), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M446.59 991.8 117.01 153.49l5.21-2.05L452.59 991.8z",
    className: "IconBestValue2025_svg__cls-52"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M440.58 991.8 111.81 155.53l5.2-2.04L446.59 991.8z",
    className: "IconBestValue2025_svg__cls-52"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M434.57 991.8 106.61 157.58l5.2-2.05L440.58 991.8z",
    className: "IconBestValue2025_svg__cls-52"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M428.56 991.8 101.4 159.63l5.21-2.05L434.57 991.8z",
    className: "IconBestValue2025_svg__cls-52"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M422.56 991.8 96.2 161.67l5.2-2.04L428.56 991.8z",
    className: "IconBestValue2025_svg__cls-52"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M416.55 991.8 91 163.72l5.2-2.05L422.56 991.8z",
    className: "IconBestValue2025_svg__cls-52"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M410.54 991.8 87.75 170.74v-5.75l3.25-1.27L416.55 991.8z",
    className: "IconBestValue2025_svg__cls-52"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M404.54 991.8 87.75 186.02v-15.28L410.54 991.8z",
    className: "IconBestValue2025_svg__cls-33"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M398.53 991.8 87.75 201.3v-15.28L404.54 991.8z",
    className: "IconBestValue2025_svg__cls-33"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M392.52 991.8 87.75 216.58V201.3l310.78 790.5z",
    className: "IconBestValue2025_svg__cls-33"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M386.51 991.8 87.75 231.86v-15.28L392.52 991.8z",
    className: "IconBestValue2025_svg__cls-33"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M380.51 991.8 87.75 247.14v-15.28L386.51 991.8z",
    className: "IconBestValue2025_svg__cls-33"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M374.5 991.8 87.75 262.42v-15.28L380.51 991.8z",
    className: "IconBestValue2025_svg__cls-33"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M368.49 991.8 87.75 277.7v-15.28L374.5 991.8z",
    className: "IconBestValue2025_svg__cls-33"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M362.49 991.8 87.75 292.98V277.7l280.74 714.1z",
    className: "IconBestValue2025_svg__cls-33"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M356.48 991.8 87.75 308.26v-15.28L362.49 991.8z",
    className: "IconBestValue2025_svg__cls-33"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M350.47 991.8 87.75 323.54v-15.28L356.48 991.8z",
    className: "IconBestValue2025_svg__cls-33"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M87.75 323.54 350.47 991.8H87.75z",
    className: "IconBestValue2025_svg__cls-33"
  }))), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M539.87 993.3c-61.24 0-120.64-11.99-176.57-35.65-54.02-22.85-102.53-55.55-144.19-97.21s-74.37-90.17-97.21-144.19c-23.65-55.93-35.65-115.33-35.65-176.57s11.99-120.64 35.65-176.57c22.85-54.02 55.55-102.53 97.21-144.19s90.17-74.37 144.19-97.21c55.93-23.65 115.33-35.65 176.57-35.65s120.64 11.99 176.57 35.65c54.02 22.85 102.53 55.55 144.19 97.21s74.37 90.17 97.21 144.19c23.65 55.92 35.65 115.33 35.65 176.57s-11.99 120.64-35.65 176.57c-22.85 54.02-55.55 102.53-97.21 144.19s-90.17 74.37-144.19 97.21c-55.93 23.65-115.33 35.65-176.57 35.65m0-904.24c-60.83 0-119.85 11.91-175.4 35.41-53.66 22.7-101.85 55.19-143.24 96.57-41.38 41.38-73.88 89.58-96.57 143.24-23.5 55.55-35.41 114.57-35.41 175.4s11.91 119.85 35.41 175.4c22.7 53.66 55.19 101.85 96.57 143.24 41.38 41.38 89.58 73.88 143.24 96.57 55.55 23.5 114.57 35.41 175.4 35.41s119.85-11.91 175.4-35.41c53.66-22.7 101.85-55.19 143.24-96.57s73.88-89.58 96.57-143.24c23.5-55.55 35.41-114.57 35.41-175.4s-11.91-119.85-35.41-175.4c-22.7-53.66-55.19-101.85-96.57-143.24-41.38-41.38-89.58-73.88-143.24-96.57-55.55-23.5-114.57-35.41-175.4-35.41",
    className: "IconBestValue2025_svg__cls-15"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M539.87 934.4c-53.29 0-104.98-10.44-153.64-31.02-47-19.88-89.22-48.34-125.47-84.59s-64.71-78.46-84.59-125.46c-20.58-48.66-31.02-100.36-31.02-153.64s10.44-104.98 31.02-153.64c19.88-47 48.34-89.22 84.59-125.47s78.46-64.71 125.47-84.59c48.66-20.58 100.36-31.02 153.64-31.02s104.98 10.44 153.64 31.02c47 19.88 89.22 48.34 125.47 84.59s64.71 78.46 84.59 125.47c20.58 48.66 31.02 100.36 31.02 153.64s-10.44 104.98-31.02 153.64c-19.88 47-48.34 89.22-84.59 125.46s-78.46 64.71-125.47 84.59c-48.66 20.58-100.36 31.02-153.64 31.02m0-786.44c-52.88 0-104.18 10.36-152.47 30.78-46.65 19.73-88.54 47.97-124.51 83.95s-64.22 77.87-83.95 124.51c-20.43 48.29-30.78 99.59-30.78 152.47s10.36 104.18 30.78 152.47c19.73 46.65 47.97 88.54 83.95 124.51 35.98 35.98 77.87 64.22 124.51 83.95 48.29 20.43 99.59 30.78 152.47 30.78s104.18-10.36 152.47-30.78c46.65-19.73 88.54-47.97 124.51-83.95s64.22-77.87 83.95-124.51c20.43-48.29 30.78-99.59 30.78-152.47S921.22 435.49 900.8 387.2c-19.73-46.64-47.97-88.54-83.95-124.51s-77.87-64.22-124.51-83.95c-48.29-20.43-99.59-30.78-152.47-30.78",
    className: "IconBestValue2025_svg__cls-15"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M539.87 962.28c-57.05 0-112.39-11.17-164.5-33.21-50.32-21.29-95.52-51.75-134.33-90.56s-69.28-84-90.56-134.33c-22.04-52.1-33.21-107.45-33.21-164.5s11.17-112.39 33.21-164.5c21.29-50.32 51.75-95.52 90.56-134.33s84-69.28 134.33-90.56c52.1-22.04 107.45-33.21 164.5-33.21s112.39 11.17 164.5 33.21c50.32 21.29 95.52 51.75 134.33 90.56s69.28 84 90.56 134.33c22.04 52.1 33.21 107.45 33.21 164.5s-11.17 112.39-33.21 164.5c-21.29 50.32-51.75 95.52-90.56 134.33s-84 69.28-134.33 90.56c-52.1 22.04-107.45 33.21-164.5 33.21m0-832.2c-55.3 0-108.94 10.83-159.43 32.19-48.77 20.63-92.58 50.16-130.2 87.78s-67.15 81.42-87.78 130.2c-21.36 50.49-32.19 104.13-32.19 159.43s10.83 108.94 32.19 159.43c20.63 48.77 50.16 92.58 87.78 130.2s81.42 67.15 130.2 87.78c50.49 21.36 104.13 32.19 159.43 32.19s108.94-10.83 159.43-32.19c48.77-20.63 92.58-50.16 130.2-87.78s67.15-81.42 87.78-130.2c21.36-50.49 32.19-104.13 32.19-159.43s-10.83-108.94-32.19-159.43c-20.63-48.77-50.16-92.58-87.78-130.2s-81.42-67.15-130.2-87.78c-50.49-21.36-104.13-32.19-159.43-32.19",
    className: "IconBestValue2025_svg__cls-15"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "m424.82 669.24-6.98 14.16-15.62 2.27 11.3 11.01-2.66 15.56 13.96-7.35 13.97 7.35-2.67-15.56 11.31-11.01-15.62-2.27zM485.29 669.24l-6.98 14.16-15.62 2.27 11.3 11.01-2.67 15.56 13.97-7.35 13.97 7.35-2.67-15.56 11.3-11.01-15.61-2.27zM541.83 669.24l-6.98 14.16-15.62 2.27 11.3 11.01-2.67 15.56 13.97-7.35 13.97 7.35-2.67-15.56 11.31-11.01-15.62-2.27zM598.37 669.24l-6.98 14.16-15.62 2.27 11.3 11.01-2.66 15.56 13.96-7.35 13.97 7.35-2.66-15.56 11.3-11.01-15.62-2.27zM654.92 669.24l-6.99 14.16-15.62 2.27 11.31 11.01-2.67 15.56 13.97-7.35 13.96 7.35-2.66-15.56 11.3-11.01-15.62-2.27zM539.7 333.66c-37.48 0-67.8-30.66-67.8-68.14s30.66-67.8 68.14-67.8 67.8 30.66 67.8 68.14c0 27.26-16.35 51.78-41.56 62.35-8.52 3.75-17.38 5.45-26.57 5.45Zm-51.1-91.99 74.95 74.95V298.9l-56.9-57.24h-18.06Zm1.36 40.54v15.33l17.72 17.72h15.67zm13.63-13.62v15.33l17.72 17.72h15.67zm30.32-26.92h-15.33l45.31 45.31v-15.33zm11.92 0 17.72 17.72v-17.72zM373.35 762.53c10.45 0 15.08 7.5 15.08 15.08s-4.62 14.94-15.08 14.94h-9.51v16.15h-9.31v-46.16h18.83Zm-.47 21.84c4.49 0 6.16-3.48 6.16-6.77s-1.67-6.83-6.03-6.83h-9.18v13.6h9.04ZM419.31 808.7l-10.99-16.55h-3.15v16.55h-9.31v-46.16h18.43c10.59 0 15.14 7.5 15.14 15.08 0 6.57-4.62 13-11.12 14.14l11.93 16.95h-10.92Zm-14.14-37.93v13.87h7.44c5.23 0 7.44-3.15 7.44-6.83s-2.34-7.04-6.7-7.04h-8.17ZM435.39 785.65c0-13.13 10.32-23.92 23.45-23.92s23.52 10.79 23.52 23.92-10.45 23.85-23.52 23.85-23.45-10.79-23.45-23.85m37.59 0c0-8.31-5.9-15.14-14.14-15.14s-14.14 6.83-14.14 15.14 5.83 15.08 14.14 15.08 14.14-6.77 14.14-15.08M526.38 808.7h-11.05l-10.52-17.22-10.59 17.22H483.3l15.95-24.66-14.54-21.51h11.26l8.84 14.14 8.91-14.14h11.12l-14.54 21.51zM560.55 762.53h11.06l-17.96 25.33v20.84h-9.31v-20.97l-17.89-25.19h11.12l11.39 17.55 11.59-17.55ZM621.38 762.53h10.12l-15.68 46.16h-7.44l-6.7-25.06-6.57 25.06h-7.44l-15.61-46.16h10.05l9.38 30.08 6.5-23.58h7.57l6.37 23.58zM663.79 808.7l-3.75-11.06h-17.29l-3.69 11.06h-9.92l17.22-46.16h10.05l17.15 46.16h-9.78Zm-18.29-19.17h11.79l-5.9-17.49-5.9 17.49ZM702.52 762.53h11.06l-17.96 25.33v20.84h-9.31v-20.97l-17.89-25.19h11.12l11.39 17.55 11.59-17.55ZM473.21 867.45h15.54v8.24H459.2v-4.76l17.15-20.57c1.81-2.21 3.01-4.49 3.01-5.96 0-2.95-2.41-5.02-5.83-5.02-3.89 0-6.1 2.55-6.63 6.37l-7.97-1.34c1.07-7.84 6.16-13.2 14.94-13.2s14.47 5.29 14.47 13.27c0 4.22-2.01 7.97-4.82 11.12l-10.32 11.86ZM495.66 853.85c0-12.66 3.62-22.65 16.42-22.65s16.21 9.98 16.21 22.65-3.55 22.65-16.21 22.65-16.42-10.18-16.42-22.65m23.65 0c0-8.11-1.61-14.47-7.24-14.47s-7.5 6.37-7.5 14.47 1.74 14.47 7.5 14.47 7.24-6.5 7.24-14.47M548.79 867.45h15.54v8.24h-29.55v-4.76l17.15-20.57c1.81-2.21 3.01-4.49 3.01-5.96 0-2.95-2.41-5.02-5.83-5.02-3.89 0-6.1 2.55-6.63 6.37l-7.97-1.34c1.07-7.84 6.16-13.2 14.94-13.2s14.47 5.29 14.47 13.27c0 4.22-2.01 7.97-4.82 11.12l-10.32 11.86ZM603.33 860.62c0 9.78-7.97 15.88-17.08 15.88-6.43 0-13.07-3.68-15.95-8.98l6.83-4.56c1.47 3.08 5.36 5.29 8.71 5.29 5.03 0 8.58-3.22 8.58-7.71s-3.42-7.37-8.11-7.37c-3.42 0-6.97 1.61-9.65 3.95l-5.16-3.28 3.82-22.11h24.99v8.17h-17.69l-1.74 8.44c2.08-1.47 4.96-2.41 8.04-2.41 8.44 0 14.41 6.23 14.41 14.67ZM326.58 543.39c0 9.5-6.5 19.7-21.7 19.7h-29.4v-68.9h27.3c12.3 0 20.2 7.4 20.2 17.8 0 5.1-2 12-9.5 14.3 8.8 1.5 13.1 9.3 13.1 17.1m-24.6-36.91h-12.6v15.1h12.6c4.4 0 7.1-2.9 7.1-7.6 0-4.2-2.2-7.5-7.1-7.5m.89 44.31c6.5 0 9.7-4.2 9.7-8.8 0-4.3-2.9-8.8-9.5-8.8h-13.7v17.6zM353.17 550.79h30.2v12.3h-44.1v-68.9h43.2v12.3h-29.3v16.4h25.7v12.5h-25.7zM392.77 543.09h13.9c.1 4.9 4.9 9 11.3 9s10.3-3.4 10.3-8.3c0-3.8-2.8-6.5-8.7-8.3l-8.4-2.4c-15.1-4-17.8-13.1-17.8-19.3 0-12.3 10.6-20.8 23.8-20.8s23 7.9 23 21h-13.9c0-4.9-3.4-8.7-9.4-8.7-5.4 0-9.5 3.6-9.5 8.2 0 1.7.5 5.2 7.7 7.3l7.7 2.2c10.4 3.1 19.5 8.4 19.5 20.1 0 13.7-11.7 21.2-24.7 21.2-14.7 0-24.8-9.1-24.8-21.2M498.77 494.18v12.3h-19v56.6h-13.9v-56.6h-19v-12.3zM561.07 494.18h14.5l-20.9 68.9h-12.5l-20.9-68.9h14.4l12.7 46.5zM624.77 563.09l-5.6-16.5h-25.8l-5.5 16.5h-14.8l25.7-68.9h15l25.6 68.9zm-27.3-28.6h17.6l-8.8-26.1zM661.17 550.79h26.1v12.3h-40v-68.9h13.9zM694.97 538.78v-44.6h13.9v43.7c0 9.4 6 13.2 12.4 13.2s12.5-3.8 12.5-13.2v-43.7h13.9v44.6c0 15.8-12.3 25.5-26.4 25.5s-26.3-9.7-26.3-25.5M777.57 550.79h30.2v12.3h-44.1v-68.9h43.2v12.3h-29.3v16.4h25.7v12.5h-25.7z",
    className: "IconBestValue2025_svg__cls-15"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1080v1080H0z",
    className: "IconBestValue2025_svg__cls-1"
  }))));
};
export default SvgIconBestValue2025;